import { detectDevice, detectBrowser } from '../utils/helpers.js';

export class AnalyticsQueue {
  constructor(maxRetries = 3, baseDelayMs = 1500) {
    this._queue      = [];
    this._maxRetries = maxRetries;
    this._baseDelay  = baseDelayMs;
    this._running    = false;
  }

  enqueue(fn, label = 'analytics') {
    this._queue.push({ fn, label, attempts: 0 });
    this._run();
  }

  async _run() {
    if (this._running || !this._queue.length) return;
    this._running = true;
    const item = this._queue[0];
    try {
      await item.fn();
      this._queue.shift();
    } catch (e) {
      item.attempts++;
      if (item.attempts >= this._maxRetries) {
        console.warn(`[MC] Analytics dropped after ${this._maxRetries} retries: ${item.label}`);
        this._queue.shift();
      } else {
        const delay = this._baseDelay * Math.pow(2, item.attempts - 1);
        await new Promise(r => setTimeout(r, delay));
      }
    }
    this._running = false;
    if (this._queue.length) this._run();
  }
}

export class AnalyticsClient {
  constructor(cfg, sessionData, queue) {
    this._cfg        = cfg;
    this._sess       = sessionData;
    this._queue      = queue;
    this.deviceType  = detectDevice();
    this.browser     = detectBrowser();
  }

  endSession(exitUrl = location.href, unloading = false) {
    const url  = `${this._cfg.apiUrl}/chat/session/end`;
    const body = JSON.stringify({
      session_id: this._sess.sessionId,
      app_id:     this._cfg.appId,
      exit_url:   exitUrl,
    });

    if (unloading) {
      if (navigator.sendBeacon) {
        const blob = new Blob([body], { type: 'application/json' });
        if (navigator.sendBeacon(url, blob)) return;
      }
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true }).catch(() => {});
      return;
    }

    this._queue.enqueue(
      () => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body }),
      'endSession'
    );
  }

  track(path, payload, label = 'track') {
    const url  = `${this._cfg.apiUrl}${path}`;
    const body = JSON.stringify(payload);
    this._queue.enqueue(
      () => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body }),
      label
    );
  }
}
